import axios from 'axios';
import {
  DEVICE_LOADING,
  DEVICE_GET_ALL_SUCCESS,
  DEVICE_ERROR,
  DEVICE_CLEAR_SNACKBAR
} from '../constants/types';

import { server_url } from '../constants/types';

export const deviceGetAll = (pagination = '') => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: DEVICE_LOADING,
        payload: {
          loading: true
        }
      });
      axios
        .get(`${server_url}/devices?${pagination}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }
        })
        .then((response) => {
          console.log("device list action");
          console.log(response.data.data);
          
          dispatch({
            type: DEVICE_GET_ALL_SUCCESS,
            payload: {
              deviceList: response.data.data,
              deviceConnectionList: [],
              connectionLogs: [],
              response: response.data,
              loading: false,
              status: "Success",
              text: 'Got data successfully'
            }
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: DEVICE_ERROR,
            payload: {
              status: 'error',
              text: 'Error occurred during getting device data.',
              loading: false
            }
          });
          resolve();
        });
    });
  };
};

export const deviceAddOrUpdate = (device, state) => {
    console.log(device)
    console.log("device")
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: DEVICE_LOADING,
        payload: {
          loading: true
        }
      });
      if (state === 'add') {
        axios
          .post(`${server_url}/devices`, device, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
          })
          .then((responseF) => {
            axios
              .get(`${server_url}/devices`, {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('authToken')
                }
              })
              .then((response) => {
                console.log("device list----- action");
                console.log(response.data.data);
                dispatch({
                  type: DEVICE_GET_ALL_SUCCESS,
                  payload: {
                    deviceList: response.data.data,
                    response: response.data,
                    loading: false,
                    status: responseF.data['status'],
                    text: responseF.data['message']
                  }
                });
                resolve();
              })
              .catch((e) => {
                dispatch({
                  type: DEVICE_ERROR,
                  payload: {
                    text: 'Error occurred during getting device data.',
                    status: 'error',
                    loading: false
                  }
                });
                resolve();
              });
          })
          .catch((e) => {
            dispatch({
              type: DEVICE_ERROR,
              payload: {
                text: 'Error occurred during adding device data.',
                status: 'error',
                loading: false
              }
            });
            resolve();
          });
      } else if (state === 'edit') {
        axios
          .put(`${server_url}/devices/${device._id}`, device, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
          })
          .then((responseF) => {
            axios
              .get(`${server_url}/devices`, {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('authToken')
                }
              })
              .then((response) => {
                dispatch({
                  type: DEVICE_GET_ALL_SUCCESS,
                  payload: {
                    deviceList: response.data.data,
                    response: response.data,
                    loading: false,
                    status: responseF.data['status'],
                    deviceDetail: responseF.data['data'],
                    text: responseF.data['message']
                  }
                });
                resolve();
              })
              .catch((e) => {
                dispatch({
                  type: DEVICE_ERROR,
                  payload: {
                    text: 'Error occurred during getting device data.',
                    status: 'error',
                    loading: false
                  }
                });
                resolve();
              });
          })
          .catch((e) => {
            dispatch({
              type: DEVICE_ERROR,
              payload: {
                text: 'Error occurred during updating device data.',
                status: 'error',
                loading: false
              }
            });
            resolve();
          });
      } else if (state === 'view') {
        axios
          .put(`${server_url}/devices/${device._id}`, {
            headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('authToken')
            }
          })
          .then((responseF) => {
            axios
              .get(`${server_url}/devices`, {
                headers: {
                  'Authorization': 'Bearer ' + localStorage.getItem('authToken')
                }
              })
              .then((response) => {
                dispatch({
                  type: DEVICE_GET_ALL_SUCCESS,
                  payload: {
                    deviceList: response.data.data,
                    response: response.data,
                    deviceDetail: responseF.data['data'],
                    loading: false,
                    status: responseF.data['status'],
                    text: responseF.data['message']
                  }
                });
                resolve();
              })
              .catch((e) => {
                dispatch({
                  type: DEVICE_ERROR,
                  payload: {
                    text: 'Error occurred during getting device data.',
                    status: 'error',
                    loading: false
                  }
                });
                resolve();
              });
          })
          .catch((e) => {
            dispatch({
              type: DEVICE_ERROR,
              payload: {
                text: 'Error occurred during updating device data.',
                status: 'error',
                loading: false
              }
            });
            resolve();
          });
      }
    });
  };
};

export const deviceDelete = (device,plant="") => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: DEVICE_LOADING,
        payload: {
          loading: true
        }
      });
      axios
        .delete(`${server_url}/devices/${device}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }
        })
        .then((responseF) => {
          axios
            .get(`${server_url}/devices?plant=${plant}`, {
              headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('authToken')
              }
            })
            .then((response) => {
              dispatch({
                type: DEVICE_GET_ALL_SUCCESS,
                payload: {
                  deviceList: response.data.data,
                  response: response.data,
                  deviceDetail: responseF.data['data'],
                  loading: false,
                  status: responseF.data['status'],
                  text: responseF.data['message']
                }
              });
              resolve();
            })
            .catch((e) => {
              dispatch({
                type: DEVICE_ERROR,
                payload: {
                  text: 'Error occurred during getting device data.',
                  status: 'error',
                  loading: false
                }
              });
              resolve();
            });
        })
        .catch((e) => {
          dispatch({
            type: DEVICE_ERROR,
            payload: {
              text: 'Error occurred during deleting device data.',
              status: 'error',
              loading: false
            }
          });
          resolve();
        });
    });
  };
};

export const deviceClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: DEVICE_CLEAR_SNACKBAR
    });
  };
};

// Device Connection List
export const deviceConnectionGetAll = (pagination = '') => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: DEVICE_LOADING,
        payload: {
          loading: true
        }
      });
      axios
        .get(`${server_url}/device/status-list?${pagination}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }
        })
        .then((response) => {
          dispatch({
            type: DEVICE_GET_ALL_SUCCESS,
            payload: {
              deviceList: [],
              connectionLogs: [],
              deviceConnectionList: response.data.data,
              response: response.data,
              loading: false,
              status: "Success",
              text: 'Got data successfully'
            }
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: DEVICE_ERROR,
            payload: {
              status: 'error',
              text: 'Error occurred during getting device data.',
              loading: false
            }
          });
          resolve();
        });
    });
  };
};

// Device Logs
export const connectionLogsGetAll = (device,pagination = '') => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: DEVICE_LOADING,
        payload: {
          loading: true
        }
      });
      axios
        .get(`${server_url}/device/status-list-logs/${device}?${pagination}`, {
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('authToken')
          }
        })
        .then((response) => {
          dispatch({
            type: DEVICE_GET_ALL_SUCCESS,
            payload: {
              deviceList: [],
              connectionLogs: response.data.data,
              deviceConnectionList: [],
              response: response.data,
              loading: false,
              status: "Success",
              text: 'Got data successfully'
            }
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: DEVICE_ERROR,
            payload: {
              status: 'error',
              text: 'Error occurred during getting device data.',
              loading: false
            }
          });
          resolve();
        });
    });
  };
};
